export const uiStates = {
  pending: {
    menuTitle: 'Смена не начата',
    buttonTheme: 'warning',
    endButtonLabel: 'Завершить смену',
  },
  started: {
    menuTitle: 'Смена начата',
    buttonTheme: 'success',
    endButtonLabel: 'Завершить смену',
  },
  ended: {
    menuTitle: 'Смена завершена',
    buttonTheme: 'danger',
    endButtonLabel: 'Обновить дату завершения',
  },
};



// WEBPACK FOOTER //
// ./src/_shared/constants/work-shift-menu/uiStates.js